import React from "react";
import "./DeleteEntryModal.css";

export default function DeleteEntryModal({ isRoot, childCount, onDeleteAll, onDeleteRoot, onDeleteSingle, onCancel }) {
  if (isRoot && childCount > 0) {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <h2>Delete Session?</h2>
          <p>
            This is this session's starting point, with{" "}
            <strong>{childCount} other {childCount === 1 ? "entry" : "entries"}</strong> linked to it.
          </p>
          <div className="modal-options">
            <button className="modal-btn modal-btn--danger" onClick={onDeleteAll}>
              🗑️ <span><strong>Delete everything</strong> — Permanently removes this entry and all {childCount} linked {childCount === 1 ? "entry" : "entries"} in the session</span>
            </button>
            <button className="modal-btn modal-btn--warning" onClick={onDeleteRoot}>
              🔓 <span><strong>Delete this entry only</strong> — Removes this session's starting point, but the other {childCount === 1 ? "entry" : "entries"} in this session will be saved but no longer grouped together</span>
            </button>
          </div>
          <button onClick={onCancel}>Cancel</button>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Delete Entry?</h2>
        <p>This cannot be undone.</p>
        <div className="modal-actions">
          <button className="modal-btn modal-btn--danger" onClick={onDeleteSingle}>Delete Entry</button>
          <button onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
